import { getService } from 'data/function';
import { StepperModal } from 'modules/ui';
export class StepperModalProcessor {
    static get ModalService() {
        return getService('ModalService');
    }
    static async process({ message, trackingProperties, source, }) {
        try {
            const modal = await StepperModalProcessor.ModalService.showModal(StepperModal(message.content));
            const modalResponse = await modal.close;
            const messageResponse = {
                response: modalResponse,
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
}
